import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  card: {
    maxWidth: 300,
    minWidth: 150
  },
  media: {
    height: 175
  },
  name: {
    color: "#877040",
    textAlign: "center"
  }
});

export default function ProfileCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardMedia className={classes.media} image={props.picture} />
      <CardContent>
        <Typography className={classes.name} component="p">
          {props.name}
        </Typography>
      </CardContent>
    </Card>
  );
}
